import React from 'react';
import PropTypes from 'prop-types';
import {motion, AnimatePresence} from 'motion/react';
import {Box, CircularProgress} from '@tenancy.nz/ui';
import SendIcon from '@mui/icons-material/Send';

const fadeEnd = {
  scale: 1,
  translateY: 1,
  opacity: 1,
};

const fadeStart = {
  scale: 0.99,
  translateY: -5,
  opacity: 0,
};

function SubmissionLoader({show}) {
  return (
    <AnimatePresence exitBeforeEnter>
      {show && (
        <motion.div
          initial={fadeStart}
          animate={fadeEnd}
          exit={fadeStart}
          transition={{
            delay: 0.25,
            duration: 0.25,
            ease: 'easeOut',
          }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            bottom: 0,
            background: 'rgba(255,255,255,0.7)',
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <CircularProgress size={200} thickness={1} />
          </Box>
          <div>
            <SendIcon
              color="primary"
              sx={{transform: 'rotate(-30deg)', fontSize: 72}}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

SubmissionLoader.propTypes = {
  show: PropTypes.bool,
};

SubmissionLoader.defaultProps = {
  show: false,
};

export default SubmissionLoader;
